// extracted by mini-css-extract-plugin
export const followUs = "FollowUs-module--follow-us--3gg7k";
export const socialList = "FollowUs-module--social-list--2zoGj";